import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  JointPersonalFormoneData,
  JointPersonalFormTwoData,
  JointPersonalFormThreeData,
  JointPersonalFormFourData,
  JointPersonalFormFiveData,
} from "app/utils/types";
interface StepsDataTypes {
  formOne?: JointPersonalFormoneData;
  formTwo?: JointPersonalFormTwoData;
  formThree?: JointPersonalFormThreeData;
  formFour?: JointPersonalFormFourData;
  formFive?: JointPersonalFormFiveData;
}

interface StepState {
  currentStep: number;
  stepsData: StepsDataTypes;
}
const initialState: StepState = {
  currentStep: 0,
  stepsData: {},
};
export const jointpersonalDetails = createSlice({
  name: "jointpersonalDetails",
  initialState,
  reducers: {
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep >= 1) state.currentStep -= 1;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStepsData: (state, action: PayloadAction<StepsDataTypes>) => {
      state.stepsData = { ...state.stepsData, ...action.payload };
    },
  },
});

export const { nextStep, prevStep, setStep, addStepsData } =
  jointpersonalDetails.actions;

export default jointpersonalDetails.reducer;
